module.exports = __webpack_public_path__ + "img/hitbtc.6bb80fd5.png";